import { replaceEqualDeep } from '@tanstack/react-query';
import { promoteOfflineFallbackDataTokens } from './offline-cache.ts';

/**
 * TanStack normally reuses a deeply-equal previous value. That would retain a
 * saved-data token after an equal live response, or discard the out-of-band
 * token when a saved response follows live data. Preserve normal structural
 * sharing everywhere else, but keep each marked transition as the new value.
 */
export function offlineQueryStructuralSharing(oldData: unknown | undefined, newData: unknown): unknown {
  const oldUsesSavedData = promoteOfflineFallbackDataTokens(oldData);
  const newUsesSavedData = promoteOfflineFallbackDataTokens(newData);
  return oldUsesSavedData || newUsesSavedData ? newData : replaceEqualDeep(oldData, newData);
}
